import { Editor } from '@tiptap/react';
import { useState } from 'react';

export const TableGridPicker = ({
  editor,
  maxRows = 6,
  maxCols = 6,
}: {
  editor: Editor;
  maxRows?: number;
  maxCols?: number;
}) => {
  const [hovered, setHovered] = useState({ row: -1, col: -1 });

  const insert = (rows: number, cols: number) => {
    editor
      .chain()
      .focus()
      .insertTable({ rows, cols, withHeaderRow: true })
      .run();
    setHovered({ row: -1, col: -1 });
  };

  return (
    <div className="flex flex-col items-center space-y-1">
      <div
        className="grid gap-0.5"
        style={{ gridTemplateColumns: `repeat(${maxCols}, 20px)` }}
      >
        {Array.from({ length: maxRows * maxCols }).map((_, i) => {
          const row = Math.floor(i / maxCols);
          const col = i % maxCols;
          const isActive = row <= hovered.row && col <= hovered.col;

          return (
            <div
              key={`${row}-${col}`}
              className={`w-5 h-5 border ${
                isActive ? 'bg-blue-400' : 'bg-zinc-700'
              } border-zinc-600 cursor-pointer`}
              onMouseEnter={() => setHovered({ row, col })}
              onClick={() => insert(row + 1, col + 1)}
            />
          );
        })}
      </div>
      {hovered.row >= 0 && hovered.col >= 0 && (
        <div className="text-xs text-white mt-1">
          {hovered.row + 1} × {hovered.col + 1}
        </div>
      )}
    </div>
  );
};
